export class Game {
  
    // Data model
    photo: string;
    
    constructor(public title: string,
                public description: string,      
                public categorie: {},   
                public catTar: string,
                public ageMin: string,
                public nbrJoeur: string,

                public visible: boolean) {
    }


  }